import { resetPasswordService } from 'services/user/resetPassword';

export const resetPassword = async (userEmailId) => {
  const { status, data } = await resetPasswordService({ userEmailId });

  if (status === 500) {
    return {
      message: 'User Doesn’t Exist',
    };
  } else if (status === 200) {
    return {
      data: data.response.secretID,
      message: 'redirect',
    };
  }

  return {
    message: 'Some error occured. Please try again after sometime.',
  };
};
